'use client'
import { useAtomValue } from 'jotai';
import { oddsPageAtom } from '@/atoms/odds-page';
import { getLeagueName, getSortedMatchCollection } from '@/utils/odds-utils';
import { SportMatchModel } from '@nf/types/odds';
import { IO } from '@nf/utils-common/fpw/monadic';
import clsx from 'clsx';
import { Card, List } from '../components/odds-page-items';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useCurrentProperties } from '@/hooks/query';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { League } from '@/features/odds-table-mars/components/league';
import { CollapseAllLeague } from '@/features/odds-table-mars/components/collapse-all-league';
import { css } from 'styled-system/css';
import { OddsTableMarsContextProvider } from '@/features/odds-table-mars/context';
interface OutrightPageProps {
	matchCollection: SportMatchModel[];
}

export const OutrightOddsTable = ({
	matchCollection
}: OutrightPageProps) => {
	const { eventMode } = useCurrentProperties();
	const searchParams = useSearchParams();
	const matchId = searchParams.get('matchId') || 0;
	const oddsData = useAtomValue(oddsPageAtom);
	const view = useAppearanceStore(state => state.view);
	const [arrangedMatchCollection, setArrangedMatchCollection] = useState<SportMatchModel[]>([]);
	const [oddsPageLayout, fontSize] = useAppearanceStore((state) => [state.oddsPageLayout, state.fontSize]);
	const [isAllLeagueExpand, setIsAllLeagueExpand] = useState<boolean>(false);
	const [isDefaultExpandStatus, setIsDefaultExpandStatus] = useState<boolean>(true);
	const containerStyle = clsx(
		{ 'odds-table-list odds-table-list--outright': oddsPageLayout === 'list' },		
		{ 'odds-table-card odds-table-card--outright': oddsPageLayout === 'card' },
		`fontsize-${fontSize}`
	);
	const getMatchCollectionByEventMode = (matchCollection: SportMatchModel[]) => {
		if (eventMode !== 'M0') {
			const modeValue = Number(eventMode.substring(1));
			return matchCollection.filter(match => match.LDM === modeValue);
		}
		return matchCollection;
	}
	const toggleAllLeague = () => {
		setIsDefaultExpandStatus(false);
		setIsAllLeagueExpand(!isAllLeagueExpand)
	};

	useEffect(() => {
		IO.of(matchCollection)
			.map(getMatchCollectionByEventMode)
			.map((t: SportMatchModel[]) => getSortedMatchCollection(t, ['MatchCode', 'LeagueId']))
			.map(setArrangedMatchCollection)
			.run();
	}, [matchCollection])

	return (
		<>
			{
				view === ViewEnum.mars ? 
					(
						<OddsTableMarsContextProvider sport={999} market={'outright'} >
							<div className={css({ p: '6px' })}>
								<CollapseAllLeague
									isAllLeagueExpand={isAllLeagueExpand}
									clickAllLeague={toggleAllLeague}
								/>
								{
									arrangedMatchCollection.map((match, index) => {
										const leagueName = getLeagueName(match.MatchId, oddsData?.leagueNameMap);
										return (
											<League
												key={`outright_${match.MatchId}`}
												leagueName={leagueName}
												matches={[match]}
												leagueId={match.MatchId}
												isAllLeagueExpand={isAllLeagueExpand || (index < 1 && isDefaultExpandStatus) || match.MatchId === Number(matchId)}
												expandMatchCount={1}
											/>
										)
									})
								}
							</div>
						</OddsTableMarsContextProvider>
					) :
					(
						<div className={containerStyle}>
							{
								arrangedMatchCollection.map((match, index) => {
									const leagueName = getLeagueName(match.MatchId, oddsData?.leagueNameMap);
									return oddsPageLayout === 'list' ?
										(
											<List
												key={`outright_list_${match.MatchId}}`}
												LeagueName={leagueName}
												Matches={[match]}
												sportId={999}
												isExpand={index < 1 || match.MatchId === Number(matchId)}
												leagueIdForMyFavourite={match.MatchId}
												LeagueGroupId={match.LeagueGroupId}
											/>
										) :
										(
											<Card
												key={`outright_card_${match.MatchId}`}
												LeagueName={leagueName}
												sportId={999}
												leagueIdForMyFavourite={match.MatchId}
												LeagueGroupId={match.LeagueGroupId}
												Matches={[match]}
												isExpand={index < 1 || match.MatchId === Number(matchId)}
											/>
										)
								})
							}
						</div>
					)
			}
		</>
	)
}